import React from 'react';
import { RowLoader } from '../component-loader';

const IssueLandingPage = () => {
  return <RowLoader />;
};

export default IssueLandingPage;
